import * as types from './mutation-types'
import collect from 'collect.js'

export default {
  [types.SET_PERIODO](state, obj) {
    return state.periodo = obj.periodo
  },
  [types.SET_INDICADORES_ABERTOS](state, obj) {
   const indicadorCollect = collect(state.indicadoresAbertos)
    if (indicadorCollect.contains(obj.id)) {
      state.indicadoresAbertos = indicadorCollect.reject(value => value ===obj.id).all()
      return
    }
    state.indicadoresAbertos = indicadorCollect.push(obj.id).all()
  },
  [types.SET_NOTAS](state,obj){
    state.notas = obj.notas
  },
  [types.SET_INDICADOR_SELECTED_ID](state,obj){
    state.indicadorSelectedId = obj.id
  }
}



// WEBPACK FOOTER //
// ./src/features/Relatorio/store/mutations.js